import { render, staticRenderFns } from "./BlogDetails.vue?vue&type=template&id=61821bdf&scoped=true&"
import script from "./BlogDetails.vue?vue&type=script&lang=ts&"
export * from "./BlogDetails.vue?vue&type=script&lang=ts&"
import style0 from "./BlogDetails.vue?vue&type=style&index=0&id=61821bdf&scoped=true&lang=css&"
import style1 from "./BlogDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61821bdf",
  null
  
)

export default component.exports